// extracted by mini-css-extract-plugin
export var heading = "pillarsOfECHO-module--heading--bb692";
export var image = "pillarsOfECHO-module--image--9900d";
export var pillar = "pillarsOfECHO-module--pillar--1498d";
export var pillars = "pillarsOfECHO-module--pillars--4bdae";